import {Component, EventEmitter, Output} from '@angular/core';
import {BsModalRef} from "ngx-bootstrap/modal";
import {AlertBannerService, AlertType} from "../../lib/alert-banner";
import {PermissionsService} from "../../services/permissions/permissions.service";
import {OrganisationService} from "../../services/organisation/organisation.service";
import {ConstantsService} from "../../services/constants/constants.service";
import {TrustMarketplaceStatusService} from "../../services/trust-marketplace-status/trust-marketplace-status.service";

@Component({
  selector: 'app-teams-manage-users',
  templateUrl: './teams-manage-users.component.pug',
  styleUrls: ['./teams-manage-users.component.scss'],
  standalone: false
})
export class TeamsManageUsersComponent {
  @Output() closeEvent = new EventEmitter<string>();

  teamName = '';
  teamId = 0;
  rolesToolTipData = '';

  turnOffLoader = true;

  total = 1;
  invitationPending = $localize`Invitation pending`;
  searchedData: any = [];
  currentPage = 1;
  rowsPerView = 20;
  sortString = 'in_current_team';
  sortOrder = 'DESC';
  filters ='';
  usersToAddInTeam: any[] = [];
  usersToRemoveFromTeam: any[] = [];

  usersData: any[] = [];

  groupDropDownOptionsDeprecated = [
    {
      'key': $localize`Team assignment`,
      'value': [
        {'label': $localize`Assigned`, 'sortString': '-in_current_team'},
        {'label': $localize`Unassigned`, 'sortString': 'in_current_team'}
      ]
    },
    {
      'key': 'group-end',
      'value': []
    },
    {
      'key': $localize`Name`,
      'value': [
        {'label': $localize`A-Z`, 'sortString': 'first_name'},
        {'label': $localize`Z-A`, 'sortString': '-first_name'}
      ]
    },
    {
      'key': 'group-end',
      'value': []
    },
    {
      'key': $localize`Email address`,
      'value': [
        {'label': $localize`A-Z`, 'sortString': 'user_email'},
        {'label': $localize`Z-A`, 'sortString': '-user_email'}
      ]
    }
  ];
  groupDropDownOptions = [
    {
      'key': $localize`Email address`,
      'value': [
        {'label': $localize`A-Z`, 'sortString': 'user_email'},
        {'label': $localize`Z-A`, 'sortString': '-user_email'}
      ]
    },
    {
      'key': 'group-end',
      'value': []
    },
    {
      'key': $localize`Name`,
      'value': [
        {'label': $localize`A-Z`, 'sortString': 'first_name'},
        {'label': $localize`Z-A`, 'sortString': '-first_name'}
      ]
    },
    {
      'key': 'group-end',
      'value': []
    },

    {
      'key': $localize`Team assignment`,
      'value': [
        {'label': $localize`Assigned`, 'sortString': '-in_current_team'},
        {'label': $localize`Unassigned`, 'sortString': 'in_current_team'}
      ]
    },
  ];

  searchOptions = [
      { label: $localize`Name`, hint: $localize`First or last name` },
      { label: $localize`Email`, hint: $localize`Email address` }
  ];
  usersTeamMapping = new Map();
  label = '';


  constructor(
    public modalRef: BsModalRef,
    private permissions: PermissionsService,
    private alertList: AlertBannerService,
    public organisationService: OrganisationService,
    public trustMarketplaceStatusService: TrustMarketplaceStatusService
  ) {
  }
  ngOnInit(): void {
    this.label = `${this.groupDropDownOptions[0].key} (${this.groupDropDownOptions[0].value[0].label})`;
    this.loadOrgUsers();
  }

  updateRole(rolesObject) {
    if (rolesObject && rolesObject.products) {
      const products = rolesObject.products;
      for (let product in products) {
        if (products.hasOwnProperty(product)) {
          const roleNumber = products[product];

          if (ConstantsService.PRODUCT_NUMBER_TO_ROLE_MAP.hasOwnProperty(roleNumber)) {
            products[product] = ConstantsService.PRODUCT_NUMBER_TO_ROLE_MAP[roleNumber];
          }
        }
      }
      for (let product in ConstantsService.DEFAULT_ROLES) {
        if (!products.hasOwnProperty(product)) {
          rolesObject.products[product] = ConstantsService.DEFAULT_ROLES[product]
        }
      }
    }
    return rolesObject
  }

  mapToolTip(UserRoles){
    let toolTipRoles = {'role':'member', products:{}}
    for(let product in ConstantsService.DEFAULT_ROLES_LOCALISED){
      if(UserRoles.products?.hasOwnProperty(product)){
        if(product === "Background Checks"){

          this.trustMarketplaceStatusService.trustAdminStatus.subscribe(
              res => {
                if(res == undefined && res != false){
                  toolTipRoles.products[ConstantsService.DEFAULT_ROLES_LOCALISED[product]] = UserRoles.products[product]
                }
              }
            );
        }
        else{
          toolTipRoles.products[ConstantsService.DEFAULT_ROLES_LOCALISED[product]] = UserRoles.products[product]
        }

      }
    }
    return JSON.stringify(toolTipRoles)
  }

  loadOrgUsers() {
    this.turnOffLoader = false;
    this.organisationService.teamUsers(this.teamId, this.searchedData, this.rowsPerView, this.currentPage, this.sortString, this.sortOrder).subscribe(data => {
      this.usersData = data['users'];
      this.usersData.forEach((user) => {
        const mappingKey = user.invitee_id
          ? `invitee_${user.invitee_id}`
          : user.user_id
            ? `user_${user.user_id}`
            : null;

        if (mappingKey) {
          if (this.usersTeamMapping.has(mappingKey)) {
            user.in_current_team = this.usersTeamMapping.get(mappingKey);
          } else {
            this.usersTeamMapping.set(mappingKey, user.in_current_team);
          }
        }
      });
      // this.translateForDisplay();
      this.total = data['total'];
      this.turnOffLoader = true;

      for (let orgUser of this.usersData) {
        if (orgUser?.role?.role === "member"){
          orgUser.roles = this.updateRole(orgUser.role)
          orgUser["rolesToolTipData"] = this.mapToolTip(orgUser.role)
        }
      }
    }, error => {
      this.turnOffLoader = true;
      this.alertList.append([{
        type: AlertType.DANGER,
        message: $localize`Oops! Something went wrong. Our developers have been notified. Feel free to try again.`,
        keepOnRouteChange: true
      }]);
    });
  }

  logEvent(event: any, eachUser: any){
    const mappingKey = eachUser.invitee_id
      ? `invitee_${eachUser.invitee_id}`
      : eachUser.user_id
        ? `user_${eachUser.user_id}`
        : null;

    if (mappingKey && this.usersTeamMapping.get(mappingKey) !== event) {
      this.usersTeamMapping.set(mappingKey, event);
    }
    if(event == true){
      if(eachUser['in_current_team'] == false){
        // append the user into the list of usersToAddInTeam
        this.usersToAddInTeam.push(eachUser);
      }
      else{
        // remove the user from list of usersToRemoveFromTeam
        this.usersToRemoveFromTeam = this.usersToRemoveFromTeam.filter(function(obj) { return obj != eachUser; });
      }
    }
    else{
      if(eachUser['in_current_team'] == true){
        // append the user into the list of usersToRemoveFromTeam
        this.usersToRemoveFromTeam.push(eachUser);
      }
      else{
        // remove the user from list of usersToAddInTeam
        this.usersToAddInTeam = this.usersToAddInTeam.filter(function(obj) { return obj != eachUser; });
      }

    }

    return event
  }

  saveButtonClicked(){

    this.turnOffLoader = false;

    let teamUsersData = {
      team_id: this.teamId,
      add_users: this.usersToAddInTeam,
      delete_users: this.usersToRemoveFromTeam
    }
    this.organisationService.modifyTeamUsers(teamUsersData).subscribe({
      next: response => {
        this.turnOffLoader = true;
        this.closeEvent.emit('team-users-modified-' + response['total_number_of_users']);
        this.modalRef?.hide();
        this.alertList.append([{
          type: AlertType.SUCCESS,
          message: $localize`Success! Changes have been saved.`,
          keepOnRouteChange: true
        }]);
      },
      error: response => {
        this.turnOffLoader = true;
      },    // errorHandler
      complete: () => {
      }, // completeHandler
    });
  }

  onSortChange(event: any){
    this.label = `${event.key} (${event.label})`;
    if(event.sortString[0] == '-'){
      this.sortString = event.sortString.slice(1);
      this.sortOrder = 'DESC';
    }
    else{
      this.sortString = event.sortString;
      this.sortOrder = 'ASC';
    }
    this.loadOrgUsers();
  }

  onPageChange(page:any): void {
    this.currentPage = page;
    this.loadOrgUsers();
  }

  onPageSizeChange(rows:any): void {
    this.rowsPerView = rows;
    this.currentPage = 1;
    this.loadOrgUsers();
  }

  textValueChanged(event: any) {
    this.searchedData[0] = {key: event['type'].toLowerCase(), value: event['search']};
    this.currentPage = 1;
    this.loadOrgUsers();
  }

  clearTags() {
    this.searchedData = [];
    this.currentPage = 1;
    this.loadOrgUsers();
  }

}
